const API_BASE = (import.meta.env.VITE_API_BASE as string | undefined) || '/api';

interface ApiResponse<T> {
  code: number;
  data: T;
  message?: string;
}

export class AuthError extends Error {
  constructor(message = '未登录') {
    super(message);
    this.name = 'AuthError';
  }
}

export async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const headers: Record<string, string> = {
    ...(options?.headers as Record<string, string>),
  };

  if (options?.body) {
    headers['Content-Type'] = 'application/json';
  }

  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    credentials: 'include',
    headers,
  });

  const result = (await response.json()) as ApiResponse<T>;

  if (response.status === 401 || result.code === 401) {
    throw new AuthError(result.message || '未登录');
  }

  if (!response.ok || result.code !== 200) {
    throw new Error(result.message || `请求失败 (${response.status})`);
  }

  return result.data;
}
